import React from 'react';
import { createDownloadLatestDocumentUrl } from '../../../../../../../API/order/documents/adminDocumentsAPI';
import { Tooltip } from '../../../../../../../ui-toolkit';
import { ISigningAppointmentDocumentResponse } from '../../../../../../../types/signingAppointment/ISigningAppointmentDocumentResponse';
import { DateFormat, getDateString } from '../../../../../../../ui-toolkit/utilities/getDateString';

export const IncomingItem: React.FC<{
  document: ISigningAppointmentDocumentResponse;
  setPreviewDoc: (docUrl: string) => void;
}> = ({ document, setPreviewDoc }) => {
  return (
    <div className="flex flex-row items-center justify-between gap-2">
      <button
        className="shrink cursor-pointer truncate text-blue-600"
        onClick={() => {
          setPreviewDoc(createDownloadLatestDocumentUrl(document.standardDocument.id));
        }}
      >
        <Tooltip
          tooltipContent={document.standardDocument.fileFileName}
          trigger="hover"
          placement="top"
          triggerClassname={'truncate'}
        >
          {document.standardDocument.fileFileName ?? ''}
        </Tooltip>
      </button>
      <div>{getDateString(DateFormat.short, document.updatedAt, false) ?? '-'}</div>
    </div>
  );
};
